import React, { Component } from "react"
import { Formik, Field, Form } from "formik"
import fields from "models/arcLot"
import * as Yup from "yup"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import settings from "settings"

class ArcModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields,
			noticeStatus: false,
			noticeDropStatus: false,
			files: {
				notice: [],
			},
			data: {
				address: "",
			},
		}
	}

	componentDidMount() {
		if (_.has(this.props, `data.arc_data`) && this.props.data.arc_data) {
			let d = this.props.data.arc_data
			let fields = _.clone(this.state.fields)
			//let fp = _.find(this.props.payload.public.floorplans, {id: d.floorplan})
			let fp = _.find(this.props.payload.public.floorplans, { id: this.props.data.floorplan })
			fields.arc_options = d.arc_options
			fields.brick = d.brick
			fields.elevation = d.elevation
			fields.garage_color = d.garage_color
			fields.accent_color = d.accent_color
			fields.roof_color = d.roof_color
			fields.siding = d.siding
			fields.stone = d.stone
			fields.stucco = d.stucco
			fields.trim = d.trim
			fields.floorplan = d.floorplan
			fields.masonry_percent = d.masonry_percent
			fields.floorplan_label = fp?.name
			fields.comments = d.comments
			fields.plan_file = d.plan_file
			fields.approval_file = d.approval_file
			fields.approval_comments = d.approval_comments
			this.setState({ fields })
		}
	}

	render() {
		return (
			<div className="modal">
				<h3>Approved Lot Plan: {this.props.data.address}</h3>
				<ul className="modalForm__list">
					<li className="form__listItem">
						<label htmlFor="floorplan">Floorplan</label>
						{this.state.fields.floorplan_label}
					</li>
					<li className="form__listItem">
						<label htmlFor="elevation">Elevation</label>
						{this.state.fields.elevation}
					</li>
					<li className="form__listItem">
						<label htmlFor="brick">Brick</label>
						{this.state.fields.brick}
					</li>
					<li className="form__listItem">
						<label htmlFor="stone">Stone</label>
						{this.state.fields.stone}
					</li>
					<li className="form__listItem">
						<label htmlFor="trim">Trim</label>
						{this.state.fields.trim}
					</li>
					<li className="form__listItem">
						<label htmlFor="siding">Siding</label>
						{this.state.fields.siding}
					</li>
					<li className="form__listItem">
						<label htmlFor="stucco">Stucco</label>
						{this.state.fields.stucco}
					</li>
					<li className="form__listItem">
						<label htmlFor="accent_color">Accent Color</label>
						{this.state.fields.accent_color}
					</li>
					<li className="form__listItem">
						<label htmlFor="garage_color">Garage Color</label>
						{this.state.fields.garage_color}
					</li>
					<li className="form__listItem">
						<label htmlFor="roof_color">Roof Color</label>
						{this.state.fields.roof_color}
					</li>
					<li className="form__listItem">
						<label htmlFor="masonry_percent">Masonry %</label>
						{this.state.fields.masonry_percent}
					</li>
					<li className="form__listItem">
						<label htmlFor="sqft">Address Specific Sq. Ft.</label>
						{this.props.data.sqft}
					</li>
					<li className="form__listItem">
						<label htmlFor="plan_file">Plan File</label>
						{this.state.fields?.plan_file ? (
							<p>
								<a
									href={`${settings.s3}${this.state.fields.plan_file}`}
									target="_blank"
									className="btn inline-block">
									View Submitted File
								</a>
							</p>
						) : (
							"No File Uploaded"
						)}
					</li>
					<li className="form__listItem">
						<label htmlFor="comments">Builder Comments</label>
						{this.state.fields.comments}
					</li>
					<li className="form__listItem">
						<label htmlFor="arc_options">Options</label>
						{this.state.fields.arc_options}
					</li>
				</ul>
				<h3>Approval Comments:</h3>
				<p>{this.state.fields.approval_comments}</p>
				{this.state?.fields?.approval_file ? (
					<p className="mt-4">
						<a
							href={`${settings.s3}${this.state.fields.plan_file}`}
							target="_blank"
							className="btn inline-block">
							View Approved File
						</a>
					</p>
				) : null}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ArcModal)
